import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Signal,
  computed,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { filter, map, startWith } from 'rxjs';
import { dataStore, db } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { doc, getDoc } from 'firebase/firestore';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss'],
  imports: [MatIcon, MatIconButton],
})
export class HelpDialogComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private router = inject(Router);

  @Output() close = new EventEmitter<void>();

  product = 'Buurtvervoer';
  userId = dataStore.orgUser?.id ?? '';
  organisationId = dataStore.selectedOrganisation?.id ?? '';
  reporterName = dataStore.orgUser?.name ?? '';
  reporterEmail = dataStore.orgUser?.email ?? '';
  reporterRoles = dataStore.orgUser?.roles?.join(', ') ?? '';
  agentKey = signal('');
  agentKeySetupError = signal(false);

  currentPage = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url),
    ),
  );

  chatUrl: Signal<SafeResourceUrl> = computed(() => {
    const baseUrl = this.getBrainsUrl();
    const params = new URLSearchParams({
      key: this.agentKey(),
      product: this.product,
      organisationId: this.organisationId,
      userId: this.userId ?? '',
      reporterEmail: this.reporterEmail ?? '',
      reporterName: this.reporterName,
      reporterRoles: this.reporterRoles,
      currentPage: this.currentPage() || this.router.url,
    });
    console.log('help url: ', `${baseUrl}?${params.toString()}`);
    return this.sanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}?${params.toString()}`);
  });

  async ngOnInit(): Promise<void> {
    try {
      const aiSettingsDoc = (await getDoc(doc(db, 'ai-settings/supportAgent'))).data();
      if (!aiSettingsDoc?.key) {
        throw new Error('Missing support agent key in ai-settings/supportAgent');
      }

      this.agentKey.set(aiSettingsDoc.key);
    } catch (error) {
      console.error('Failed to load support agent key from Firestore:', error);
      this.agentKeySetupError.set(true);
    }
  }

  getBrainsUrl(): string {
    if (environment.production) {
      return 'https://app.wemaronbrains.com/chat';
    }
    if (environment.functionsUrl.includes('staging')) {
      return 'https://staging.wemaronbrains.com/chat';
    }
    return 'https://dev.wemaronbrains.com/chat';
  }
}
